import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, Button } from '@bliks-io/ui';

interface LoadErrorRetryProps {
  message: string;
  onRetry: () => void;
  loading?: boolean;
}

/** A failed read's message with a Retry button that reads it again. */
export function LoadErrorRetry({ message, onRetry, loading }: LoadErrorRetryProps) {
  const { t } = useTranslation();
  return (
    <Alert colorScheme="error">
      <AlertDescription>{message}</AlertDescription>
      <Button type="button" variant="outline" className="mt-3" loading={loading} onClick={onRetry}>
        {t('common.retry')}
      </Button>
    </Alert>
  );
}
